var map = {
	"./en/addAmenity.json": 2364,
	"./en/addItemSteps.json": 2259,
	"./en/common.json": 1997,
	"./en/confirmStorageDetails.json": 1721,
	"./en/createOrder.json": 9014,
	"./en/guests.json": 1897,
	"./en/items.json": 2814,
	"./en/linenInventory.json": 2542,
	"./en/listOrders.json": 6465,
	"./en/lockDevices.json": 3584,
	"./en/login.json": 345,
	"./en/orderDetails.json": 6016,
	"./en/prepareLinenOrder.json": 2731,
	"./en/reservations.json": 6775,
	"./en/saveOrder.json": 7779,
	"./en/settings.json": 9561,
	"./en/stockCount.json": 6501,
	"./en/storageDetailsSection.json": 9426,
	"./en/storageLV.json": 4895,
	"./en/vendor.json": 3488,
	"./ja/addAmenity.json": 9370,
	"./ja/addItemSteps.json": 9565,
	"./ja/common.json": 5839,
	"./ja/confirmStorageDetails.json": 943,
	"./ja/createOrder.json": 6848,
	"./ja/guests.json": 9791,
	"./ja/items.json": 7544,
	"./ja/linenInventory.json": 3244,
	"./ja/listOrders.json": 6847,
	"./ja/lockDevices.json": 6670,
	"./ja/login.json": 6355,
	"./ja/orderDetails.json": 1330,
	"./ja/prepareLinenOrder.json": 9573,
	"./ja/reservations.json": 429,
	"./ja/saveOrder.json": 5757,
	"./ja/settings.json": 8339,
	"./ja/stockCount.json": 9504,
	"./ja/storageDetailsSection.json": 3900,
	"./ja/storageLV.json": 1393,
	"./ja/vendor.json": 8346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7453;